export class CountBySubCategoryGroupReq{
	startDate : string;
	endDate: string;
	divisionId : number ;
	clientCode : string;
	group : number;
	categoryId : number;
	subCategoryIds: number[];
	groupBy: string;
	date: string;
}